import api from "../../api";
import {AxiosResponse} from "axios";
import {AgencyModuleServiceInterface} from "../../types";
import {BaseAddResponse, BaseEditResponse} from "../../types/response";
import {
    AgencyAddRequest,
    AgencyEditRequest,
    AgencyListRequest,
    AgencyPrepareEditFormRequest, AgencyViewRequest
} from "../../types/modules/agency/request";
import {
    AgencyPrepareAddFormResponse, AgencyPrepareEditFormResponse, AgencyViewHistoryResponse,
    AgencyViewResponse
} from "../../types/modules/agency/response";
import {AgencyListResponse} from "../../types/modules/agency/response";

export class AgencyService implements AgencyModuleServiceInterface {
    public list(request: AgencyListRequest): Promise<AxiosResponse<AgencyListResponse>> {
        return api.get('/company_administration/agency/', { params: request });
    }
    public edit(request: AgencyEditRequest): Promise<AxiosResponse<BaseEditResponse>> {
        return api.put(`/company_administration/agency/${request.id}/edit`, request);
    }
    public view(request: AgencyViewRequest): Promise<AxiosResponse<AgencyViewResponse>> {
        return api.get(`/company_administration/agency/${request.id}/view`);
    }
    public add(request: AgencyAddRequest): Promise<AxiosResponse<BaseAddResponse>> {
        return api.post(`/company_administration/agency/add`, request);
    }
    public prepareEditForm(request: AgencyPrepareEditFormRequest): Promise<AxiosResponse<AgencyPrepareEditFormResponse>> {
        return api.get(`/company_administration/agency/${request.id}/prepare_edit`);
    }
    public prepareAddForm(): Promise<AxiosResponse<AgencyPrepareAddFormResponse>> {
        return api.get(`/company_administration/agency/prepare_add`);
    }
    public viewHistory(request: AgencyViewRequest): Promise<AxiosResponse<AgencyViewHistoryResponse>> {
        return api.get(`/company_administration/agency/${request.id}/view_history`);
    }
}